// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"481":"3c51f3be","615":"ee661489"}[chunkId] + ".chunk.js";
};